/*
  You may have to change some chrome flags to have cross-site cookies,
  as explained in https://support.google.com/chrome/thread/26291731?hl=en :

  You can retain the legacy behaviour for cookies in the browser by setting both of these flags to "Disabled"
    chrome://flags/#same-site-by-default-cookies
    chrome://flags/#cookies-without-same-site-must-be-secure
  These are both currently supported through to at least Chrome 83.

  This may also be enforced using Enterprise Policies as detailed in
  https://www.chromium.org/administrators/policy-list-3/cookie-legacy-samesite-policies
*/

import { getCaRTT } from '@/helpers/authUtils';
import { env, efaContentID, efaContentParentID, ENV } from '@/helpers/constants';
import { EfaWidgetConfig } from '@/types';

declare global {
  interface Window {
    SSLWidgetConfig: any;
    SSLWidget_v6: any;
  }
}

const urls = {
  [ENV.LOCAL]: 'https://mrssh1-caas-int.app.corpintra.net',
  [ENV.DEV]: 'https://mrssh1-caas-int.app.corpintra.net',
  [ENV.INT]: 'https://mrssh1-caas-int.app.corpintra.net',
  old1: 'https://mrs050-w90dev.e.corpintra.net',
  old2: 'https://mrs050-w90mnt.app.corpintra.net',
  [ENV.PRO]: 'https://mrssh1-caas.app.corpintra.net',
};
const url = urls[env];
const loadCSS = () => {
  const link = document.createElement('link');
  link.href = `${url}/widgets/quality/sslnavigation/v6/themes/dai/dai.css`;
  link.type = 'text/css';
  link.rel = 'stylesheet';
  document.getElementsByTagName('head')[0].appendChild(link);
};

const startWidget = (baumuster = {}, callback = () => { }) => {
  loadCSS();

  window.SSLWidget_v6.init(`${url}/widgets/quality/sslnavigation/v6/`, 'SSLWidgetConfig', () => {
    window.SSLWidget_v6.start('SSLWidgetConfig', () => { // widget is now loaded
      const openStartPictureFunc = window.SSLWidgetConfig.openStartPicture;

      if (openStartPictureFunc) {
        const widgetConfigurations = {
          showFaultType: true,
          disableNavigation: false,
          fetchFaultLocationSize: 10,
        };

        openStartPictureFunc(baumuster, widgetConfigurations).then(callback); // finished loading start picture
      }
    });
  });
};

const resetContainer = () => {
  const parent = document.getElementById(efaContentParentID);
  let efaContainer = document.getElementById(efaContentID);
  const efaLoaded = document.getElementsByClassName('P93_ssl-widget');

  if (efaLoaded.length > 0 && parent) {
    efaLoaded[0].remove();
    efaContainer = document.createElement('section');
    efaContainer.id = efaContentID;
    parent.appendChild(efaContainer);
  }
};

export const loadWidget = (
  config: EfaWidgetConfig,
  loadingCallback = () => { },
  okCallback = (re) => { },
  errorCallback = (re) => { },
  connectionErrorCallback = (re) => { },
) => {
  resetContainer();

  window.SSLWidgetConfig = {
    backendURL: `${url}/efai-services`,
    attachNode: efaContentID,
    dialogLanguage: config.dialogLanguage,
    dataLanguage: config.dataLanguage,
    systemLanguage: config.systemLanguage,
    translationLanguage: config.translationLanguage,
    // functions called by widget, set by integration app
    onOK(resultObj) {
      okCallback(resultObj);
    },
    onError(errorObj) {
      console.error(`onError: ${errorObj._errorTitle}: ${errorObj._errorDetail} ErrorCode: ${errorObj._errorCode}`);
      errorCallback(errorObj);
    },
    onCancel() {
      console.log('onCancel: EXIT');
      errorCallback(undefined);
    },
    // functions called by integration app, set by widget
    openStartPicture: Function,
    openFaultLocation: Function,
    openSelectedFaultLocation: Function,
    destroySSLWidget: Function,
  };

  const sslwidgetScript = document.createElement('script');
  sslwidgetScript.src = `${url}/widgets/quality/sslnavigation/v6/sslwidget-loader.js`;
  sslwidgetScript.onload = () => { startWidget(config.baumuster, loadingCallback); };

  sslwidgetScript.onerror = (event) => {
    if (event instanceof Event) {
      console.log('Error loading', event.target);
    } else {
      console.log('Error loading');
    }
    connectionErrorCallback(undefined);
  };
  document.body.appendChild(sslwidgetScript);
};

export const checkConnection = (
  config: EfaWidgetConfig,
  loadingCallback: (() => void),
  okCallback: ((re: any) => void),
  efaErrorCallback: ((re: any) => void),
  connectionErrorCallback: ((re: any) => void),
) => {
  const request = new XMLHttpRequest();
  const cartt = getCaRTT();

  request.onerror = connectionErrorCallback;
  request.ontimeout = connectionErrorCallback;
  request.onload = () => {
    if (request.status >= 200 && request.status < 300) {
      loadWidget(config, loadingCallback, okCallback, efaErrorCallback, connectionErrorCallback);
      return;
    }

    connectionErrorCallback(request);
  };

  request.open('GET', `${url}/efai-services/efaiMasterData/version`);
  request.setRequestHeader('Authorization', `Bearer ${cartt}`);
  request.withCredentials = true;
  request.send();
};
